module.exports = __webpack_public_path__ + "img/scene_8.86ce4494.jpg";